import apiHandler from "../core/apiHandler";

const initialStockAdminApi = apiHandler("inventory/initial-stock-admin");
export default initialStockAdminApi;
